mod.modules.define("ChartSymbolSearch", "SymbolSearchBase", function (fn) {

    fn.prototype.init = function (params) {
        this.base("init", params);

       this.el.modAutocomplete("option", "position", {
            my: "left top",
            at: "right top",
            collision: "none",
            of: this.el.parent(),
            offset: "0 -24"
        });
    };

});